<template>
    <div id="shareManagement" class="shareManagement">
        <div class="page-content">
            <div class="page-content-head">
                <el-row>
                    <el-col :span="12">
                        <button class="cancel-btn" @click.prevent="batchCancel">取消分享</button>
                        <button class="refresh-btn" @click.prevent="getShareFileList(modelPageId)">
                            <i class="fa fa-refresh"></i> 刷新
                        </button>
                    </el-col>
                </el-row>
            </div>
            <div class="page-table-content">
                <div class="type-list">
                    <el-collapse v-model="activeList">
                        <el-collapse-item
                            v-for="(item, index) in typeItems"
                            :title="item.name"
                            :name="item.id"
                            :key="index"
                        >
                            <ul>
                                <li
                                    v-for="(item2, index) in item.children"
                                    class="listItem"
                                    :class="{ activeItem: currentType === item2.name }"
                                    :key="index"
                                    @click="getChangeList(item2)"
                                >
                                    {{ item2.name }}
                                </li>
                            </ul>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="table-warp">
                    <el-table
                        v-loading="isTableLoading"
                        ref="multipleTable"
                        class="table-container"
                        height="95%"
                        tooltip-effect="dark"
                        size="mini"
                        border
                        fit
                        highlight-current-row
                        :data="modelsData"
                        :row-class-name="tableRowClassName"
                        :row-style="{ height: '50px', 'font-size': '14px' }"
                        :cell-style="{ padding: '0px' }"
                        :header-cell-style="{
                            'background-color': '#F5F5F5',
                            'font-size': '14px',
                            height: '50px',
                            color: '#666666',
                            'font-weight': '400',
                        }"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="50"> </el-table-column>
                        <el-table-column prop="fileName" label="文件名称" min-width="10%"> </el-table-column>
                        <el-table-column prop="shareTime" label="分享时间" min-width="10%"> </el-table-column>
                        <el-table-column prop="shareLink" label="链接" min-width="15%" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div>
                                    {{ scope.row.shareLink }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shareAging" label="分享时效" min-width="5%" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div>
                                    {{ scope.row.shareAging !== -1 ? scope.row.shareAging + '天' : '永久有效' }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="公开/保密" min-width="7%" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <!-- 公开保密 -->
                                <!-- <el-switch
                style="display: flex"
                v-model="scope.row.shareStatus"
                active-color="rgba(53,155,255,1)"
                inactive-color="rgba(255,73,41,1)">
              </el-switch> -->
                                <div
                                    v-if="scope.row.shareStatus"
                                    style="color: rgba(53, 155, 255, 1); margin-left: 5px"
                                >
                                    公开
                                </div>
                                <div
                                    v-if="!scope.row.shareStatus"
                                    style="color: rgba(255, 73, 41, 1); margin-left: 5px"
                                >
                                    保密
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="12%">
                            <template slot-scope="scope">
                                <!-- 查看 -->
                                <i class="icon iconfont iconliulan-moren icon view" @click="viewModel(scope.row)"></i>
                                <!-- 二维码 -->
                                <!-- <i
                                class="icon iconfont iconerweima-moren"
                                @click="handleQRCode(scope.$index, scope.row)"
                            ></i> -->
                                <!-- 更多 -->
                                <!-- <el-dropdown class="needMore icon" @command="handleCommand">
                                <i class="fa fa-ellipsis-h" @mouseenter="handleRow(scope.row)"></i>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="reShare">重新分享</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown> -->
                                <el-button class="copy-text-btn" type="text" @click="copyModelUrl(scope.row)">
                                    复制</el-button
                                >
                                <!-- 取消分享 -->
                                <el-button class="cancel-text-btn" type="text" @click="cancelChangeModel(scope.row)">
                                    X 取消分享</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="paging">
                        <el-pagination
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            layout="prev, pager, next"
                            :total="totalCount"
                        ></el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getUserName } from 'src/utils/loginUtils';
import { formatTime } from 'src/utils/commonUtils';
import { getShareList, cancelShare } from 'src/utils/shareUtils';

export default {
    name: 'shareManagement',
    components: {},
    data() {
        return {
            // 默认页数
            currentPage: 1,
            // 数据总条数
            totalCount: 0,
            modelPageId: '',
            multipleSelection: [],
            value1: '',
            input2: '',
            options: [],
            bucket_key: '',
            currentRow: {},
            modelsData: [],
            activeList: [10],
            currentType: '全部类型',
            typeItems: [
                {
                    name: '分享类型',
                    id: 10,
                    children: [
                        {
                            name: '全部类型',
                            id: -1,
                        },
                        {
                            name: '模型视图',
                            id: 0,
                        },
                        {
                            name: '模型文件',
                            id: 1,
                        },
                        {
                            name: '模型组装',
                            id: 2,
                        },
                        // {
                        //     name: '模型对比',
                        //     id: 3,
                        // },
                        {
                            name: 'LOD模型',
                            id: 4,
                        },
                        {
                            name: 'LOD组装',
                            id: 5,
                        },
                    ],
                },
            ],
            isTableLoading: false,
        };
    },
    methods: {
        // 当前页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getShareFileList(-1);
        },
        getChangeList(type) {
            this.currentPage = 1;
            this.currentType = type.name;
            this.modelPageId = type.id;
            this.getShareFileList(this.modelPageId);
        },
        uploadModel() {
            this.$refs.fileMngUpload.Open();
        },
        handleRow(row) {
            this.currentRow = row;
        },
        handleCommand(command) {
            switch (command) {
                case 'reShare':
                    break;
            }
        },
        handleQRCode() {},
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 !== 0) {
                return 'even-row';
            }
            return 'odd-row';
        },
        // 取消多个文件分享
        batchCancel() {
            if (!this.multipleSelection.length) {
                this.$message({ type: 'error', message: '请选中需要取消的分享' });
                return;
            }

            this.$confirm('此操作将取消文件分享, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    const multiPro = this.multipleSelection.map((ele) => ele.shareId);
                    cancelShare(multiPro).then((res) => {
                        this.$message({ type: 'success', message: '取消成功!' });
                        this.getShareFileList(this.modelPageId); //刷新页面
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作',
                    });
                });
        },
        // 刷新页面/获取当前分享列表
        getShareFileList(type) {
            const _self = this;
            if (this.modelPageId === '') {
                this.modelPageId = -1;
            }
            let query = {
                type: type,
                pageNumber: this.currentPage,
                pageSize: 10,
            };
            let list = [];
            getShareList(query)
                .then((res) => {
                    this.isTableLoading = false;
                    this.totalCount = res.totalPage * 10;
                    if (res.items.length !== 0) {
                        res.items.forEach((item) => {
                            const urnList = item.urn;
                            const urnObject = urnList.split(',')[0].split('"')[3];
                            let guidObject = '';
                            if (urnList.length - urnList.split(',')[0].length !== 0) {
                                guidObject = urnList.split(',')[1].split('"')[3];
                            }
                            list.push({
                                fileName: item.name,
                                shareTime: formatTime(item.createAt),
                                createTime: item.createAt,
                                shareLink: `${window.location.origin}/devcenter/shareView/${item.id}`,
                                shareAging: item.expiration,
                                shareStatus: item.isOpen === 0,
                                shareId: item.id,
                                shareUrn: urnObject,
                                shareGuid: guidObject,
                                shareType: item.type,
                            });
                        });
                    }
                    _self.modelsData = list;
                })
                .catch(() => {
                    this.isTableLoading = false;
                });
        },
        // 模型查看
        viewModel(row) {
            // 判断是否超时
            const currentTime = new Date();
            const userTime = (currentTime.getTime() - row.createTime) / (1000 * 3600 * 24);
            if (userTime < row.shareAging || row.shareAging === -1) {
                const tempURL = `${window.location.origin}/devcenter/shareView/${row.shareId}`;
                window.open(tempURL, '_blank');
            } else {
                this.$message.error('分享已超时');
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 取消单个分享
        cancelChangeModel(row) {
            this.$confirm('此操作将取消文件分享, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    const cancelObject = [];
                    cancelObject.push(row.shareId);
                    cancelShare(cancelObject).then((res) => {
                        this.$message({
                            type: 'success',
                            message: '取消成功!',
                        });
                        this.getShareFileList(this.modelPageId); //刷新页面
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作',
                    });
                });
        },
        // 复制模型地址
        copyModelUrl(row) {
            const tagValue = `${window.location.origin}/devcenter/shareView/${row.shareId}`;
            this.$copyText(tagValue).then(
                (res) => {
                    this.$message.success('复制成功');
                },
                (err) => {
                    this.$message.error('复制失败');
                },
            );
        },
    },
    mounted() {
        this.isTableLoading = true;
        // bucket 初始化
        // this.bucket_key = `${getUserName()}_bucket`;
        this.bucket_key = `${getUserName()}`;
        this.getShareFileList(-1);
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.shareManagement >>>
  .el-table-column--selection .cell
    dom_center()
  .el-table td, .el-table th.is-leaf
    border 0px
  .el-table--border th, .el-table__fixed-right-patch
    border 0px
  .el-table
    user-select text
    background-color transparent
  .el-table .odd-row
    background #FFFFFF
  .el-table .even-row
    background #F8F8F8
  .el-col
    display flex
    align-items center
  .el-input__inner
    border-radius 20px
.shareManagement >>>
  .el-table__row
    .icon
      font-size 18px
      color $font-title
      opacity 0.5
      padding 0px 10px
      &:hover
        color #0C78E2
        opacity 1
    .icon.view
      font-size 16px
    .copy-text-btn
      padding-left 2%
      color #0C78E2
      font-weight bold
      opacity 1
    .cancel-text-btn
      padding-left 7%
      color rgb(255, 170, 62)
      font-weight bold
      opacity 1
.shareManagement
  background-color $background-darkwhite
  width 88%
  .page-content
    height 100%
    .page-content-head
      height 7%
      min-height 60px
      .el-row
        height 100%
        .el-col
          height 100%
          .cancel-btn
            width 100px
            height 40px
            margin-left 4%
            border-radius 20px
            border 0px
            outline none
            background-color rgb(255, 170, 62)
            i
              font-size 16px
          .refresh-btn
            width 100px
            height 40px
            margin-left 10px
            border-radius 20px
            border 0px
            outline none
            background-color #0C78E2
            i
              font-size 16px
    .page-table-content
      width 100%
      height 93%
      display flex
      .type-list >>>
        .el-collapse
          margin-top 0px
        .el-collapse-item__header
          height 50px
          border-bottom 2px
          border-style solid
          border-color $background-darkwhite
        .el-collapse-item
          background-color $background-white
        .el-collapse-item__content
          padding-bottom 0px
          border-bottom 2px
          border-style solid
          border-color $background-darkwhite
      .type-list
        width 9%
        min-width 145px
        margin-left 10px
        margin-right 10px
        .listItem
          border 0px
          height 50px
          font-size 14px
          dom_center()
          box-sizing border-box
          &:hover
            background-color #F5F5F5
            color $font-activeBlue
          &.activeItem
            background-color #F5F5F5
            color $font-activeBlue
  .table-warp
    width 100%
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/shareManagement/shareManagement.vue